export const ALLOCATIONS = {
    CONTROL: '1',
    TEST_B: '2',
    TEST_C: '3',
    TEST_D: '4',
};

export const EXPERIMENTS = {
    CAT_LISTINGS_PRICE_BUCKETS: 3456,
    CARIBOU_RATING_SCORE_UPDATES: 4268,
};

export const ROLLOUTS = {};
